// // src/components/NewsList.js
import React, { useState } from "react";
import "../styles/NewsList.css";
import iconfox from "../images/fox.png";
import iconnyt from "../images/nyt.png";
import icontds from "../images/tds.png";
import iconalj from "../images/alj.png";
import icondw from "../images/dw.png";
import logo from '../images/logo.news-index.png';

const NewsList = ({ news }) => {
  // State to track user-selected sentiments
  const [userSentiments, setUserSentiments] = useState({});

  const getSentimentClass = (sentiment) => {
    switch (sentiment) {
      case "positive":
        return "NewsItem-positive";
      case "negative":
        return "NewsItem-negative";
      case "neutral":
        return "NewsItem-neutral";
      default:
        return "NewsItem";
    }
  };

  // Icon for source
  const getIcon = (link) => {
    if (link.includes("foxnews.com")) {
      return (
        <div className="NewsLogo">
          <img src={iconfox} alt="FoxNews Logo" title="FoxNews Logo" />
        </div>
      );
    } else if (link.includes("nytimes.com")) {
      return (
        <div className="NewsLogo">
          <img src={iconnyt} alt="NewYork Times Logo" title="NewYork Times Logo" />
        </div>
      );
    } else if (link.includes("thedailystar.net")) {
      return (
        <div className="NewsLogo">
          <img src={icontds} alt="The Daily Star Logo" title="The Daily Star Logo" />
        </div>
      );
    } else if (link.includes("aljazeera.com")) {
      return (
        <div className="NewsLogo">
          <img src={iconalj} alt="Al Jazeera Logo" title="Al Jazeera Logo" />
        </div>
      );
    } else if (link.includes("dw.com")) {
      return (
        <div className="NewsLogo">
          <img src={icondw} alt="DW Logo or Deutsche Welle Logo" title="Deutsche Welle Logo" />
        </div>
      );
    } else {
      return null;
    }
  };

  // Attribution for source
  const getAttribution = (link) => {
    if (link.includes("foxnews.com")) {
      return (
        <div className="attribution">
          
          © This article is published on <a href={link} target="_blank" rel="noopener noreferrer">FoxNews</a>. All rights reserved by the original content owner.
            We do not claim ownership or endorsement of the content and recommend visiting the original site for full access.
          
        </div>
      );
    } else if (link.includes("nytimes.com")) {
      return (
        <div className="attribution">
          
          © This article is published on <a href={link} target="_blank" rel="noopener noreferrer">NewYorkTimes</a>. All rights reserved by the original content owner.
            We do not claim ownership or endorsement of the content and recommend visiting the original site for full access.
          
        </div>
      );
    } else if (link.includes("thedailystar.net")) {
      return (
        <div className="attribution">
          
          © This article is published on <a href={link} target="_blank" rel="noopener noreferrer">TheDailyStar</a>. All rights reserved by the original content owner.
            We do not claim ownership or endorsement of the content and recommend visiting the original site for full access.
          
        </div>
      );
    } else if (link.includes("aljazeera.com")) {
      return (
        <div className="attribution">
          
          © This article is published on <a href={link} target="_blank" rel="noopener noreferrer">Al Jazeera</a>. All rights reserved by the original content owner.
            We do not claim ownership or endorsement of the content and recommend visiting the original site for full access.
         
        </div>
      );
    } else if (link.includes("dw.com")) {
      return (
        <div className="attribution">
          
          © This article is published on <a href={link} target="_blank" rel="noopener noreferrer">DW or Deutsche Welle</a>. All rights reserved by the original content owner.
            We do not claim ownership or endorsement of the content and recommend visiting the original site for full access.
         
        </div>
      );
    } else {
      return null;
    }
  };

  // Handle sentiment change by the user and send it to the API
  const handleSentimentChange = async (index, sentiment) => {
    setUserSentiments(prevSentiments => ({
      ...prevSentiments,
      [index]: sentiment,
    }));

    // Define the API URL
    let url = `${process.env.REACT_APP_API_URL}/user_sentiment`;

    // Prepare the data to send
    const data = {
      sentiment: sentiment,
      title: news[index].title, // Assuming you have an ID for each news item
    };

    try {
      // Make the API POST request
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });

      // Check if the request was successful
      if (response.ok) {
        console.log(`Sentiment "${sentiment}" for news ${news[index].title} successfully sent to the server.`);

        // Disable Review for that Article
        const buttons = document.querySelectorAll(`.btn-id-${index}`);
        // Disable each element
        buttons.forEach((button) => {
          button.disabled = true;
        });


      } else {
        console.error(`Failed to send sentiment: ${response.statusText}`);
      }
    } catch (error) {
      console.error('Error sending sentiment:', error);
    }
  };

  return (
    <div className="NewsList">
      {news.map((item, index) => (
        <div
          className={`NewsItem ${getSentimentClass(userSentiments[index] || item.sentiment)}`}
          key={index}
        >
          {getIcon(item.link)}
          <div className="article-card">
            <div className="article-image">
              <a href={item.link} target="_blank" rel="noopener noreferrer">
                <img src={item.content_image.includes("media/logo.news-index.") ? logo : item.content_image} alt={item.title} title={item.title} />
              </a>

            </div>
            <div className="article-info">
              <h3>
                <a href={item.link} target="_blank" rel="noopener noreferrer">
                  {item.title}
                </a>
              </h3>
              <p className="NewsItemPublishedTime">
                {new Date(item.pub_date).toLocaleString()}
              </p>
              <p>{item.description}....<a href={item.link} target="_blank" rel="noopener noreferrer">
                <strong>Read more</strong>
              </a>...</p>
            </div>
          </div>

          <div className="user-sentiment">
              <label>Your Sentiment Review:</label>
              <div className="sentiment-buttons">
                <button
                  className={`sentiment-button-positive btn-id-${index} ${userSentiments[index] === "positive" || item.sentiment === "positive" ? "selected" : ""}`}
                  onClick={() => handleSentimentChange(index, "positive")}
                >
                  Positive
                </button>
                <button
                  className={`sentiment-button-negative btn-id-${index} ${userSentiments[index] === "negative" || item.sentiment === "negative" ? "selected" : ""}`}
                  onClick={() => handleSentimentChange(index, "negative")}
                >
                  Negative
                </button>
                <button
                  className={`sentiment-button-neutral btn-id-${index} ${userSentiments[index] === "neutral" || item.sentiment === "neutral" ? "selected" : ""}`}
                  onClick={() => handleSentimentChange(index, "neutral")}
                >
                  Neutral
                </button>
              </div>
            </div>

            {getAttribution(item.link)}

        </div>
      ))}
    </div>
  );
};

export default NewsList;
